export const YEARLY_SUMMARY_CONSTS = {
  moduleName: 'epb-yearly-summary',

  getters: {
    yearlySummaryAlreadyViewed: 'yearlySummaryAlreadyViewed'
  },

  actions: {
    setYearlySummaryAlreadyViewed: 'setYearlySummaryAlreadyViewed',
  },

  mutations: {
    setYearlySummaryAlreadyViewed: 'setYearlySummaryAlreadyViewed'
  },

  storage: {
    yearlySummaryAlreadyViewed: 'yearly-summary-already-viewed'
  }

};
